import React, { createContext } from 'react'
import { useRequest } from '../fetchboi/hooks'
import CongressDisplay from './CongressDisplay'

export const CongressContext = createContext({})

export default function CongressProvider ({ children, congressSlug }) {
  const [congress, loading] = useRequest({ url: `/congresses/${congressSlug}` })

  const generateLink = (link) => {
    return `/${congress?.Slug}${link}`
  }

  if (loading) {
    return <CongressDisplay loading={loading}/>
  } else if (!congress && !loading) {
    // Render Error
    return <CongressDisplay
      error="El evento no existe"
      description={<span>No hemos podido encontrar un congreso con el identificador <b>{congressSlug}</b>. Asegurate que la URL del evento esté correcta.</span>}/>
  } else if (congress && !loading) {
    return (
      <CongressContext.Provider value={{ congress, generateLink }}>
        {children}
      </CongressContext.Provider>
    )
  }
}
